import React, { useEffect, useState } from 'react';
import { Product } from 'data/terra/Product';
import './ProjectListPopup.scss';
import ProjectIcon from './ProjectIcon';
import { Project } from 'data/terra/Project';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { fetchProjects } from 'v2/store/projectList/actions/FetchProjects';
import { Input } from 'antd';
import { toLowerCaseNonAccentVietnamese, toLowerCaseNonAccentVietnameseMemo } from '../../../util/String';
import { t } from 'helpers/i18n';

interface ProjectListPopupProps {
  currentProject: Product | undefined;
}

const ProjectListPopup: React.FC<ProjectListPopupProps> = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { projects, hasInitialized } = useSelector(
    (state: RootState) => state.projectList
  );
  const { currentProject } = props;
  const [displayProjects, setDisplayProjects] = useState<Project[]>([]);
  const [searchText, setSearchText] = useState<string>();

  useEffect(() => {
    if (!hasInitialized) {
      dispatch(fetchProjects());
    }
  }, [hasInitialized]);

  function isProjectMatchWithSearchContent(
    project: Project,
    searchContent?: string
  ): boolean {
    if (!searchContent) {
      return true;
    }
    const nonVietnameseSearchText = toLowerCaseNonAccentVietnamese(
      searchContent
    );

    const nonVietnameseProjectName = toLowerCaseNonAccentVietnameseMemo(
      project.projectName
    );

    return nonVietnameseProjectName.includes(nonVietnameseSearchText);
  }

  useEffect(() => {
    const displayProjects = [...projects].filter(project =>
      isProjectMatchWithSearchContent(project, searchText)
    );
    let selectedIdx = displayProjects.findIndex(
      p => p.projectId === currentProject?.id
    );
    if (selectedIdx !== -1) {
      let selectedProject = displayProjects.splice(selectedIdx, 1);
      setDisplayProjects(selectedProject.concat(displayProjects));
    } else {
      setDisplayProjects(displayProjects);
    }
  }, [projects, currentProject, searchText]);

  const onSearchTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  return (
    <div className="project-list-popup">
      <Input
        className="search-view"
        autoFocus
        placeholder={t('project_config_search_project')}
        onChange={onSearchTextChange}
      />
      <div id="project-list-popup-inner" className="project-list-popup-inner">
        {displayProjects.map(p => (
          <ProjectIcon
            key={p.projectCode}
            project={p}
            checked={p.projectId === currentProject?.id}
            textStyle={{ color: '#1B1D29' }}
            onClick={(project: Project) => {
              history.push(`/v2/projects/${project.projectId}/app-config`);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectListPopup;
